import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { dashboardsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { WidgetPositioning } from "@src/types/dashboards";

// PATCH replaces the whole positioning map; body: { positioning: {...} }.
// Returns the full updated dashboard.
export const patchPositioningV2 = async (
  namespace: string,
  dashboardId: string,
  positioning: Record<string, WidgetPositioning>,
): Promise<{ data: unknown }> => {
  const url = dashboardsUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.patch(
      `${url}/api/v2/ns/${namespace}/dashboards/${dashboardId}/positioning`,
      { positioning },
      { headers },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to save widget position. Please try again later.",
      );
    }
    throw new Error(
      "An unexpected error occurred while saving widget position.",
    );
  }
};
